import { StaticImage } from "gatsby-plugin-image"
import React from "react"

export const advantagesSlides = [
	{
		img: (
			<StaticImage
				src="./assets/wl-advantages-1.png"
				alt="Без комиссии агрегаторов"
				objectFit="contain"
				placeholder="blurred"
				quality={90}
			/>
		),
		title: "Без комиссии агрегаторов",
		description:
			"Собери свой штат курьеров. \nОрганизуй собственную доставку \nи&nbsp;не&nbsp;плати комиссию сторонним \nсервисам.",
	},
	{
		img: (
			<StaticImage
				src="./assets/wl-advantages-2.png"
				alt="Всегда на связи с гостями"
				objectFit="contain"
				placeholder="blurred"
				quality={90}
			/>
		),
		title: "Всегда на связи с гостями",
		description:
			"Мотивируй пользоваться приложением чаще. Оповещай гостей об&nbsp;акциях, скидках, накопленных баллах.",
	},
	{
		img: (
			<StaticImage
				src="./assets/wl-advantages-3.png"
				alt="Да, это бесплатно"
				objectFit="contain"
				placeholder="blurred"
				quality={90}
			/>
		),
		title: "Да, это бесплатно",
		description:
			"Готовое приложение для кафе и&nbsp;сайт без сторонних дизайнеров и&nbsp;студии. Прими первый заказ уже через 5&nbsp;минут.",
	},
]
